// extracted by mini-css-extract-plugin
export default {"checkboxesWrapper":"FiltersWithHeader_checkboxesWrapper__PiDp+"};